<script>
  import { _ as t, locale } from "svelte-i18n";
  import { client } from "sanityClient.js";

  import ArrowLink from "components/ArrowLink.svelte";

  import Divider from "components/Divider.svelte";
  import Download from "components/Download.svelte";
  import RichText from "components/RichText.svelte";

  const query = '*[_type == "frontPage"] {welcome, intro, about}[0]';
  const params = {};

  const frontPageQuery = client.fetch(query, params);
</script>

{#await frontPageQuery then frontPage}
  <div class="above">
    <div class="welcome">
      <h1>{frontPage.welcome[$locale]}</h1>
      <p class="subheader">{frontPage.intro[$locale]}</p>

      <ArrowLink text={$t("moreinfo")} anchor="#news" />
    </div>
  </div>

  <Divider />

  <section class="main">
    <div class="closing" id="news">
      <RichText content={frontPage.about[$locale]} />

      <div class="file">
        <Download
          text={$t("downloads.flyer")}
          href={$locale === "de"
            ? "/media/ILK_Flyer_DE.pdf"
            : "/media/ILK_Flyer_FR.pdf"}
        />
      </div>
    </div>
  </section>
{/await}

<style>
  .main {
    max-width: 900px;
    margin-bottom: 6rem;
  }

  .above {
    height: calc(100vh - 48rem);
    min-height: 500px;
    max-height: 1000px;
    position: relative;
  }

  .welcome {
    position: absolute;
    bottom: 0;
    padding-bottom: 50px;
  }

  h1 {
    margin: 20px 0;
    font-weight: 200;
    font-size: 32px;
  }

  .subheader {
    max-width: 600px;
    margin: 0;
    font-weight: 200;
  }

  .closing {
    margin-top: 80px;
  }

  .file {
    margin: 45px 0;
  }

  @media only screen and (min-width: 600px) {
    h1 {
      font-size: 50px;
    }

    .subheader {
      font-size: 18px;
    }

    .closing {
      margin-top: 40px;
      max-width: 700px;
    }
  }
</style>
